const messages = {
  title: "Bonus",
  word: "Bonus",
  description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
};

export default {
  messages,
};
